<script setup>
import { inject } from 'vue'
import { getTournamentTypeIcon } from '@/services/utils'
import Group from './Group.vue';

const tournament = inject('tournament')
const currents = inject('currents')

const level = currents.value.level
const stage = currents.value.stage
</script>

<template>
  <!-- Stage title only if there are more stages -->
  <h3 v-if="level.stages_count > 1"
    class="mb-4"
  >
    <v-icon class="me-1">{{ getTournamentTypeIcon(stage.type) }}</v-icon>
    {{ stage.name }}
  </h3>

  <template v-for="(group, index) in stage.groups" :key="group.id">
    <Group
      v-model="stage.groups[index]"
    />
  </template>
</template>
